import Entity from "./entity";
export default class User extends Entity<number> {
  password: string;
}



// WEBPACK FOOTER //
// ./src/store/entities/purchase.ts